import React, { Component } from "react";
import {
  POST,
  loading,
  alert,
  mode,
  setDarkMode,
} from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class ResendVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword_token: "",
      password: "",
      confirm_password: "",
    };
  }
  componentDidMount() {
    let resetpassword_token = window.location.pathname.replace(
      "/change-password/",
      ""
    );
    resetpassword_token = atob(resetpassword_token);
    if (Number(resetpassword_token.split(":")[2]) < new Date().getTime()) {
      alert(
        "/",
        "warning",
        "Warning",
        "This link has expired. Please try again."
      );
    } else {
      this.setState({ resetpassword_token });
    }
    if (mode === "dark") {
      setDarkMode();
    }
    loading(false);
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }
  ChangePassword = async () => {
    const { resetpassword_token, password, confirm_password } = this.state;
    if (!password) {
      alert("", "warning", "Warning", "Please input Password");
      return;
    } else if (password.trim().length < 6) {
      alert(
        "",
        "warning",
        "Warning",
        "Please enter a password that is at least 6 characters long."
      );
      return;
    } else if (!confirm_password) {
      alert("", "warning", "Warning", "Please input Confirm Password");
      return;
    } else if (password !== confirm_password) {
      alert("", "warning", "Warning", "Password not match");
      return;
    }
    loading(true);

    let result = await POST("v1/public/change-password", {
      uid: resetpassword_token.split(":")[0] || "",
      password: btoa(password),
    });
    if (result?.status) {
      alert(
        "/",
        "success",
        "Success",
        "Your account has had its password changed."
      );
    }
    loading(false);
  };

  render() {
    const { resetpassword_token, password, confirm_password } = this.state;
    return resetpassword_token ? (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
            />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-8 col-xl-7 mx-auto my-5 auth-card">
              <h3 className="fw-bold text-dark mb-3">Reset password</h3>
              <label className="mb-1">Password</label>
              <input
                type="password"
                className="form-control mb-3"
                placeholder="Password..."
                onChange={(e) => {
                  this.setState({ password: e.target.value });
                }}
                value={password}
              />
              <label className="mb-1">Confirm Password</label>
              <input
                type="password"
                className="form-control mb-3"
                placeholder="Confirm Password..."
                onChange={(e) => {
                  this.setState({ confirm_password: e.target.value });
                }}
                value={confirm_password}
              />
              <button
                type="button"
                className="btn btn-dark w-100 mb-3"
                onClick={() => {
                  this.ChangePassword();
                }}
              >
                Confirm
              </button>
              <div className="w-100 text-center">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
                <br />
                <br />
                <a href="/" className="text-decoration-none text-dark">
                  Return to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div></div>
    );
  }
}
